import { TKV2_ORDER_ATTACHMENT_API } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetCompRecommendationError,
  GetCompRecommendationVariables,
  fetchGetCompRecommendation,
} from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_ORDER_ATTACHMENT_API.COMP_RECOMMENDATION.GET;

export const useGetCompRecommendation = (
  variables: GetCompRecommendationVariables,
  opts?: Omit<
    UseQueryOptions<z.infer<typeof API_SCHEMA.RESPONSE>, GetCompRecommendationError>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<z.infer<typeof API_SCHEMA.RESPONSE>, GetCompRecommendationError> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<z.infer<typeof API_SCHEMA.RESPONSE>, GetCompRecommendationError>({
    queryKey: queryKeyFn({
      path: '/api/v2/orders/{orderID}/compRecommendation',
      operationId: 'getCompRecommendation',
      variables,
    }),
    queryFn: async ({ signal }) => {
      const res = await fetchGetCompRecommendation({ ...fetcherOptions, ...variables }, signal);
      return API_SCHEMA.RESPONSE.parse(res);
    },
    ...opts,
  });
};
